import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=58e9a28f&scoped=true&"
import script from "./receipt.vue?vue&type=script&lang=ts&"
export * from "./receipt.vue?vue&type=script&lang=ts&"
import style0 from "./receipt.vue?vue&type=style&index=0&id=58e9a28f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e9a28f",
  null
  
)

export default component.exports